import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import {
    Table,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    TableHead,
    Box,
    Modal,
    CircularProgress
} from '@mui/material';
import PDFError from './pdfError';
import ButtonPrimary from "./ButtonPrimary";
import COLORS from '../styles/colors.json';

dayjs.extend(utc);
dayjs.extend(timezone);

const MAX_VISIBLE_ROWS = 10;

const STYLE = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: COLORS.white,
    borderRadius: 2,
    padding: 1
};

const formatDate = (date, timeZone) => {
    const dateLocal = dayjs(date);
    const dateTimeZone = dateLocal.tz(timeZone);
    return dateTimeZone.format('MM/DD/YYYY hh:mm:ss A');
}

const DocumentTable = (props) => {
    const {
        documents,
        loading,
        handleButtonClick,
        timeZone
    } = props;

    const showScroll = documents && documents.length > MAX_VISIBLE_ROWS;

    const renderButton = (id) => {
        if (id === loading) {
            return <CircularProgress/>;
        } else {
            return (
                <ButtonPrimary
                    onClick={() => handleButtonClick(id)}
                    sx={{ "margin-left": 10 }}
                    disabled={!!loading}
                >
                    OPEN
                </ButtonPrimary>
            )
        }
    }

    const renderRows = () => {
        return documents.map(({ key, version, date }) => {
            return (
                <TableRow>
                    <TableCell>
                        {formatDate(date, timeZone)}
                    </TableCell>
                    <TableCell>
                        {version}
                    </TableCell>
                    <TableCell>
                        {renderButton(key)}
                    </TableCell>
                </TableRow>
            )
        })
    }
    
    
    return (
        <TableContainer
            sx={{
                borderLeft: '1px solid #EEEEEE',
                borderRight: '1px solid #EEEEEE',
                maxHeight: showScroll ? '60vh' : 'auto'
            }}
        >
            <Table stickyHeader sx={{ minWidth: 500 }}>
                <TableHead>
                    <TableRow>
                            <TableCell
                                sx={{
                                    fontWeight: 600,
                                    color: COLORS.white,
                                    backgroundColor: COLORS.redDarker,
                                    zIndex: 2 
                                }}
                            >
                                TIMESTAMP
                            </TableCell>
                            <TableCell
                                sx={{
                                    fontWeight: 600,
                                    color: COLORS.white,
                                    backgroundColor: COLORS.redDarker,
                                    zIndex: 2
                                }}
                            >
                                VERSION
                            </TableCell>
                            <TableCell sx={{ backgroundColor: COLORS.redDarker, zIndex: 2 }}>
                                
                            </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {renderRows()}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default function WorkOrderDocuments(props) {
    const {
        id,
        dataType,
        timeZone,
        documents,
        open,
        handleClose,
        handleWorkOrderButtonClick,
        workOrderDocumentLoading,
        error
    } = props;
    
    const render = () => {
        if (error) {
            return (
                <PDFError
                    id={id}
                    dataType={dataType}
                    handleButtonClick={handleClose}
                />
            )
        } else {
            return (
                <Box sx={STYLE} >
                    <DocumentTable
                        documents={documents}
                        timeZone={timeZone}
                        handleButtonClick={handleWorkOrderButtonClick}
                        loading={workOrderDocumentLoading}
                    />
                </Box>                
            )
        }
    }

    return (
        <Modal
            open={open}
            onClose={handleClose}
        >
            {render()}
        </Modal>
    )
}